import { useEffect } from "react";
import { useWizard } from "react-use-wizard";
import { useDispatch } from "react-redux";
import { setCurrentStep } from "store/modules/auth";

const useCurrentStep = () => {
	const { activeStep } = useWizard();
	const dispatch = useDispatch();

	useEffect(() => {
		// Zapisujemy aktualny krok do Redux store
		dispatch(setCurrentStep(activeStep));
	}, [activeStep, dispatch]);

	return null;
};

export default useCurrentStep;
